
import Section from "./Section.vue";
export default {
  components: {
    Section,
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      tabsData: [
        {
          id: "<15",
          title: "Dưới 15tr/năm",
          desc: "Các trường có mức học phí dưới 15tr mỗi năm",
        },
        {
          id: "15-30",
          title: "15-30tr/năm",
          desc: "Các trường có mức học phí dưới từ 15tr đến 30tr mỗi năm",
        },
        {
          id: "31-50",
          title: "31-50tr/năm",
          desc: "Các trường có mức học phí dưới từ 31tr đến 50tr mỗi năm",
        },
        {
          id: ">50",
          title: "Trên 50tr/năm",
          desc: "Các trường có mức học phí trên 50tr mỗi năm",
        },
      ],
    };
  },
};
